import { render, staticRenderFns } from "./BankChoose.vue?vue&type=template&id=2b107f9a&scoped=true"
import script from "./BankChoose.vue?vue&type=script&lang=js"
export * from "./BankChoose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b107f9a",
  null
  
)

export default component.exports